import React, { useEffect } from 'react';
import WOW from 'wow.js';
import 'animate.css/animate.css';

const Businesses = () => {
    useEffect(() => {
        const wow = new WOW();
        wow.init();
      }, []);
  return (
    <div className='businesses'>
        <div className="businesses-inner">
            
            <div className="business-text">
            <h2 class="section-heading main-title wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">Who we work with</h2>
            <p className="wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s" >As a leading Web development company in Pakistan, We worked with 100+ businesses either it is a start-up or enterprise and delivers the best solution in the industry. At Web Gurus Hub, we offer a broad range of web development services based on business requirements.</p>
            </div>
            <div className="business-cards wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
                    <div className="col-1">
                        <img src="https://i.ibb.co/3dpFXGx/u1.png" alt="" />
                        <h4>Start Up Business</h4>
                    </div>
                    <div className="col-1">
                        <img src="https://i.ibb.co/kDFrDtd/u2.png" alt="" />
                        <h4>Small & Medium Business</h4>
                    </div>
                    <div className="col-1">
                        <img src="https://i.ibb.co/M16mYb3/u3.png" alt="" />
                        <h4>Enterprise</h4>
                    </div>
                    <div className="col-1">
                        <img src="https://i.ibb.co/zfVy42C/u4.png" alt="" />
                        <h4>Agencies</h4>
                    </div>
                </div>
            </div>
    </div>
  )
}


export default Businesses